import {
  AccountBookOutlined,
  AppstoreAddOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BarcodeOutlined,
  BgColorsOutlined,
  BookOutlined,
  CalculatorOutlined,
  ColumnWidthOutlined,
  ControlOutlined,
  CreditCardOutlined,
  DatabaseOutlined,
  DollarOutlined,
  EditFilled,
  EnvironmentOutlined,
  EditOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  GoldOutlined,
  InboxOutlined,
  KeyOutlined,
  LineChartOutlined,
  ProfileOutlined,
  QrcodeOutlined,
  RollbackOutlined,
  ScissorOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  SkinOutlined,
  SwapOutlined,
  TagOutlined,
  TagsOutlined,
  TeamOutlined,
  TrademarkOutlined,
  UserOutlined,
} from "@ant-design/icons";

export const SHIMMER_STYLE = `
  @keyframes shimmerSweep {
    0%   { transform: translateX(-100%); }
    60%  { transform: translateX(100%); }
    100% { transform: translateX(100%); }
  }

  .sb-shimmer {
    background: linear-gradient(160deg, #130560 0%, #1a0870 40%, #250a85 70%, #2d0d9e 100%);
  }

  .shimmer-item {
    position: relative;
    overflow: hidden;
  }

  .shimmer-item::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
  105deg,
  transparent 15%,
  rgba(255,255,255,0.05) 30%,
  rgba(255,255,255,0.15) 40%,
  rgba(255,255,255,0.25) 50%,
  rgba(255,255,255,0.15) 60%,
  rgba(255,255,255,0.05) 70%,
  transparent 85%
);
    transform: translateX(-100%);
    animation: shimmerSweep 3.5s ease-in-out infinite;
    pointer-events: none;
  }

  .shimmer-item:nth-child(1)::after  { animation-delay: 0.0s; }
  .shimmer-item:nth-child(2)::after  { animation-delay: 0.3s; }
  .shimmer-item:nth-child(3)::after  { animation-delay: 0.6s; }
  .shimmer-item:nth-child(4)::after  { animation-delay: 0.9s; }
  .shimmer-item:nth-child(5)::after  { animation-delay: 1.2s; }
  .shimmer-item:nth-child(6)::after  { animation-delay: 1.5s; }
  .shimmer-item:nth-child(7)::after  { animation-delay: 1.8s; }
  .shimmer-item:nth-child(8)::after  { animation-delay: 2.1s; }
  .shimmer-item:nth-child(9)::after  { animation-delay: 2.4s; }
  .shimmer-item:nth-child(10)::after { animation-delay: 2.7s; }

  .shimmer-item-dynamic {
    position: relative;
    overflow: hidden;
  }

  .shimmer-item-dynamic::after {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--shimmer-bg, linear-gradient(
      105deg,
      transparent 30%,
      rgba(255,255,255,0.06) 48%,
      rgba(255,255,255,0.12) 50%,
      rgba(255,255,255,0.06) 52%,
      transparent 70%
    ));
    transform: translateX(-100%);
    animation: shimmerSweep 3.5s ease-in-out infinite var(--shimmer-delay, 0s);
    pointer-events: none;
  }

  /* CSS tooltip */
  [data-tooltip] { position: relative; }
  [data-tooltip]::after {
    content: attr(data-tooltip);
    position: fixed;
    left: auto;
    pointer-events: none;
    background: rgba(20, 10, 60, 0.97);
    color: #ffffff;
    font-size: 11px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    padding: 4px 9px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 9999;
    box-shadow: 0 2px 10px rgba(0,0,0,0.4);
    border: 1px solid rgba(255,255,255,0.18);
    transform: translateY(-50%);
    margin-left: 6px;
  }
  [data-tooltip]:hover::after { opacity: 1; }
`;

// NOTE: "masters" and "utilities" are NOT in USER1_KEYS. Add them here if
// the restricted (USER1) user should also see the Settings section.
export const USER1_KEYS = ["pos"];
export const USER2_KEYS = [
  "masters",
  "top",
  "inventory",
  "pos",
  "accounts",
  "crm",
  "purchase",
  "utilities",
];

export const ALL_GROUPS = [
  {
    key: "top",
    label: "Top Ten",
    short: "Top",
    color: "#b026ff",
    count: 1,
    accordianTitle: "Reports & Analysis",
    icon: <FileDoneOutlined />,
    subGroups: [
      {
        key: "top-process",
        label: "Top Ten Process",
        icon: <BarcodeOutlined />,
        items: [
          {
            label: "Top 10 Invoice",
            path: "/top-ten-invoices",
            icon: <AppstoreOutlined />,
          },
          {
            label: "Top 10 Brands",
            path: "/top-ten-brands",
            icon: <AppstoreAddOutlined />,
          },
          {
            label: "Top 10 Prices",
            path: "/top-ten-prices",
            icon: <ShopOutlined />,
          },
          {
            label: "Top 10 Sales Man",
            path: "/top-ten-salesman",
            icon: <ControlOutlined />,
          },
          {
            label: "Top 10 Products",
            path: "/top-ten-products",
            icon: <TagsOutlined />,
          },
        ],
      },
    ],
  },
  {
    key: "inventory",
    label: "Inventory",
    short: "Inventory",
    color: "#4cdb5f", // Neon Green
    count: 2,
    accordianTitle: "Reports & Analysis",
    icon: <FileDoneOutlined />,
    subGroups: [
      {
        key: "barcode-process",
        label: "Barcode Process",
        icon: <BarcodeOutlined />,
        items: [
          {
            label: "Stock Point",
            path: "/stock-point",
            icon: <InboxOutlined />,
          },
          {
            label: "Commodity Wise Stock",
            path: "/purchase-type-wise-stock",
            icon: <TagOutlined />,
          },
          {
            label: "Product Wise Stock",
            path: "/product-wise-stock",
            icon: <QrcodeOutlined />,
          },
          {
            label: "HSN Wise Stock",
            path: "/hsn-wise-stock",
            icon: <EditFilled />,
          },
          {
            label: "Brand Wise Stock",
            path: "/brand-wise-stock",
            icon: <EditOutlined />,
          },
          {
            label: "Dealer Wise Stock",
            path: "/dealer-wise-stock",
            icon: <TagOutlined />,
          },
          {
            label: "Group Wise Stock",
            path: "/group-wise-stock",
            icon: <SwapOutlined />,
          },
          {
            label: "Bar Code Check",
            path: "/bar-code-check",
            icon: <SwapOutlined />,
          },
        ],
      },
    ],
  },
  {
    key: "pos",
    label: "Point of Sale",
    short: "POS",
    color: "#00e5ff", // Neon Cyan
    count: 3,
    accordianTitle: "Reports & Analysis",
    icon: <ShopOutlined />,
    subGroups: [
      {
        key: "point-of-sale",
        label: "Point of Sale",
        icon: <CalculatorOutlined />,
        items: [
          {
            label: "Sale Invoice",
            path: "/sale-invoice",
            icon: <FileTextOutlined />,
          },
          {
            label: "Sale Return",
            path: "/sale-return",
            icon: <RollbackOutlined />,
          },
          {
            label: "Exchange Bill",
            path: "/exchange-bill",
            icon: <ShoppingCartOutlined />,
          },
        ],
      },
      {
        key: "day-glance",
        label: "Day Glance & Analysis",
        icon: <AuditOutlined />,
        items: [
          {
            label: "Day Glance",
            path: "/day-glance",
            icon: <ProfileOutlined />,
          },
          {
            label: "Sale Register",
            path: "/sale-register",
            icon: <FileSearchOutlined />,
          },
        ],
      },
    ],
    moduleReports: [
      {
        key: "sale-reports",
        label: "Sale Reports",
        icon: <BarChartOutlined />,
        items: [
          { label: "Day Glance", path: "/day-glance" },
          { label: "Sale Register", path: "/sale-register" },
          { label: "Return Register", path: "/return-register" },
          { label: "Product Wise Sales", path: "/product-wise-sale" },
          { label: "Brand Wise Sale", path: "/brand-wise-sale" },
          { label: "Dealer Wise Sale", path: "/dealer-wise-sale" },
          { label: "Sales Man Wise Sale", path: "/salesman-wise-sale" },
          { label: "Date Wise Sale", path: "/date-wise-sale" },
          { label: "Commodity Wise Sale", path: "/commodity-wise-sale" },
          { label: "Tax Wise Sale", path: "/tax-wise-sale" },
          { label: "HSN Wise Sale", path: "/hsn-wise-sale" },
          { label: "Group Wise Sale", path: "/group-wise-sale" },
        ],
      },
    ],
  },
  {
    key: "accounts",
    label: "Accounts",
    short: "Accounts",
    color: "#ff3366",
    count: 4,
    accordianTitle: "Reports & Analysis",
    icon: <DollarOutlined />,
    subGroups: [
      {
        key: "account-sub",
        label: "Accounts",
        icon: <CalculatorOutlined />,
        items: [
          {
            label: "OutStanding Customers",
            path: "/outstanding-customers",
            icon: <CreditCardOutlined />,
          },
          {
            label: "Outstanding Dealers",
            path: "/outstanding-dealers",
            icon: <ProfileOutlined />,
          },
          {
            label: "Cash Book",
            path: "/cash-book",
            icon: <AccountBookOutlined />,
          },
          {
            label: "Bank Statement",
            path: "/bank-statement",
            icon: <SwapOutlined />,
          },
          {
            label: "Reciept Register",
            path: "/receipt-register",
            icon: <DatabaseOutlined />,
          },
          {
            label: "Payment Register",
            path: "/payment-register",
            icon: <ShoppingCartOutlined />,
          },
          {
            label: "Purchase Register",
            path: "/purchase-register",
            icon: <GoldOutlined />,
          },
          {
            label: "Journal Register",
            path: "/journal-register",
            icon: <BookOutlined />,
          },
          {
            label: "Sales Men Wise Commission",
            path: "/salesmen-wise-commission",
            icon: <BankOutlined />,
          },
        ],
      },
    ],
  },
  {
    key: "purchase",
    label: "Purchase",
    short: "Order",
    color: "#ff6a00", // Neon Orange
    count: 5,
    accordianTitle: "Reports & Analysis",
    icon: <ShoppingCartOutlined />,
    subGroups: [
      {
        key: "order-process",
        label: "Purchase Process",
        icon: <CalculatorOutlined />,
        items: [
          {
            label: "Purchase Invoice",
            path: "/purchase-invoice",
            icon: <CalculatorOutlined />,
          },
          {
            label: "Commodity Wise Purchase",
            path: "/commodity-wise-purchase",
            icon: <CalculatorOutlined />,
          },
          {
            label: "Product Wise Purchase",
            path: "/product-wise-purchase",
            icon: <FileSearchOutlined />,
          },
          {
            label: "Dealer Wise Purchase",
            path: "/dealer-wise-purchase",
            icon: <FileSearchOutlined />,
          },
          {
            label: "HSN Wise Purchase",
            path: "/hsn-wise-purchase",
            icon: <FileSearchOutlined />,
          },
          {
            label: "Brand Wise Purchase",
            path: "/brand-wise-purchase",
            icon: <FileSearchOutlined />,
          },
          {
            label: "Tax Wise Purchase",
            path: "/tax-wise-purchase",
            icon: <FileSearchOutlined />,
          },
          {
            label: "Excel Upload Purchase",
            path: "/file-import",
            icon: <FileSearchOutlined />,
          },
        ],
      },
    ],
  },
  {
    key: "crm",
    label: "CRM",
    short: "CRM",
    color: "#00ffcc", // Neon Mint
    count: 6,
    accordianTitle: "Reports & Analysis",
    icon: <TeamOutlined />,
    subGroups: [
      {
        key: "crm-process",
        label: "CRM Process",
        icon: <CalculatorOutlined />,
        items: [
          {
            label: "Today Birthday's",
            path: "/today-birthdays",
            icon: <CalculatorOutlined />,
          },
          {
            label: "Today Anniversaries",
            path: "/today-anniversaries",
            icon: <FileSearchOutlined />,
          },
          {
            label: "Total Dues",
            path: "/total-dues",
            icon: <FileSearchOutlined />,
          },
          {
            label: "Graphs",
            path: "/graphs",
            icon: <FileSearchOutlined />,
          },
          {
            label: "MailBook Register",
            path: "/mail-book-register",
            icon: <FileSearchOutlined />,
          },
        ],
      },
    ],
  },

  // ── SETTINGS GROUPS (shown as two tiles, not in the Modules list) ─────
  {
    key: "masters",
    label: "Masters",
    short: "Masters",
    color: "#b026ff",
    icon: <AppstoreOutlined />,
    items: [
      {
        label: "Area Master",
        path: "/area-master",
        icon: <EnvironmentOutlined />,
      },
      {
        label: "State Master",
        path: "/state-master",
        icon: <BankOutlined />,
      },
      {
        label: "Purchase Type Master",
        path: "/purchase-type-master",
        icon: <ShoppingCartOutlined />,
      },
      {
        label: "Main Product",
        path: "/main-product",
        icon: <AppstoreOutlined />,
      },
      {
        label: "Product Category",
        path: "/product-category",
        icon: <AppstoreAddOutlined />,
      },
      {
        label: "Product Master",
        path: "/product-master",
        icon: <ShopOutlined />,
      },
      {
        label: "Brand Master",
        path: "/brand-master",
        icon: <TrademarkOutlined />,
      },
      {
        label: "Item Category",
        path: "/item-category",
        icon: <AppstoreAddOutlined />,
      },
      {
        label: "Item Master",
        path: "/item-master",
        icon: <ShopOutlined />,
      },
      {
        label: "Size Master",
        path: "/size-master",
        icon: <ColumnWidthOutlined />,
      },
      {
        label: "Colour Master",
        path: "/colour-master",
        icon: <BgColorsOutlined />,
      },
      {
        label: "Fashion Master",
        path: "/fitting-master",
        icon: <SkinOutlined />,
      },
      {
        label: "Offer Master",
        path: "/sleeves-master",
        icon: <ScissorOutlined />,
      },
      {
        label: "Dealer Master",
        path: "/dealer-master",
        icon: <BankOutlined />,
      },
      {
        label: "Code Master",
        path: "/code-master",
        icon: <BarcodeOutlined />,
      },
    ],
  },
  {
    key: "utilities",
    label: "Utilities",
    short: "Utilities",
    color: "#22d3ee",
    icon: <SettingOutlined />,
    items: [
      {
        label: "User Accounts",
        path: "/user-accounts",
        icon: <UserOutlined />,
      },
      {
        label: "Firm Configuration",
        path: "/firm-configuration",
        icon: <BankOutlined />,
      },
      {
        label: "Upload Image",
        path: "/upload-image",
        icon: <BankOutlined />,
      },
      {
        label: "Whatsapp SMS Templates",
        path: "/whatsapp-sms-templates",
        icon: <UserOutlined />,
      },
      {
        label: "Counter Config",
        path: "/counter-config",
        icon: <UserOutlined />,
      },
      {
        label: "User Account Manager",
        path: "/user-account-manager",
        icon: <BankOutlined />,
      },
      {
        label: "User Permissions",
        path: "/user-permissions",
        icon: <KeyOutlined />,
      },
    ],
  },
];

export const THEMES = {
  royalBlue: {
    id: "royalBlue",
    label: "Royal Blue",
    goldAccent: "#d4af37",
    iconColorActive: "#ffffff",
    cardBorderInactive: "#64748B",
    cardHoverBorder: "rgba(212,175,55,0.25)",
    bgHover: "rgba(255,255,255,0.08)",
    bg: "#0B024F",
    bgSolid: "#0B024F",
    shimmerBody:
      "linear-gradient(160deg,#130560 0%,#1a0870 40%,#250a85 70%,#2d0d9e 100%)",
    shimmerHighlight: "rgba(255,255,255,0.28)",
    bgCard: "rgba(255,255,255,0.06)",
    bgCardActive: "rgba(102,187,149,0.55)",
    bgActive: "rgba(55,143,103,0.22)",
    cardBorder: "rgba(255,255,255,0.14)",
    borderActive: "rgba(102,187,149,0.55)",
    cardIconBg: "rgba(255,255,255,0.10)",
    cardIconBgActive: "rgba(255,255,255,0.22)",
    headerBorder: "rgba(255,255,255,0.08)",
    dashboardBorder: "rgba(255,255,255,0.18)",
    accordionBorder: "rgba(255,255,255,0.18)",
    accordionBodyBorder: "rgba(255,255,255,0.13)",
    accordionBodyDivider: "rgba(255,255,255,0.07)",
    sectionBar: "#c084fc",
    sectionHeadingColor: "#c084fc",
    iconColor: "#fbbf24",
    text: "rgba(219,228,255,0.88)",
    textMuted: "rgba(219,228,255,0.55)",
    textActive: "#ffffff",
    dashboardText: "#e2e8ff",
    reportsText: "#ffffff",
    chevronColor: "rgba(255,255,255,0.80)",
    accent: "#66BB95",
    accentBg: "rgba(102,187,149,0.18)",
    cardHoverBg: "rgba(212,175,55,0.08)",
    cardHoverShadow: "0 6px 18px rgba(212,175,55,0.18)",
    dashboardBg: "rgba(255,255,255,0.07)",
    reportDotInactive: "rgba(255,255,255,0.25)",
    activeIndicatorDot: "#ffffff",
    pickerBg: "rgba(255,255,255,0.06)",
    pickerBgHover: "rgba(255,255,255,0.11)",
    pickerDropdownBg: "rgba(20,10,60,0.97)",
    pickerItemSelectedBg: "rgba(255,255,255,0.10)",
    pickerItemHoverBg: "rgba(255,255,255,0.07)",
    pickerItemText: "rgba(255,255,255,0.75)",
    pickerItemBorder: "rgba(255,255,255,0.06)",
    scrollbarColor: "rgba(255,255,255,0.18)",
    tooltipBg: "rgba(20,10,60,0.97)",
    neonMasters: {
      from: "#7c3aed",
      to: "#a855f7",
      glow: "rgba(168,85,247,0.55)",
    },
    neonUtilities: {
      from: "#0ea5e9",
      to: "#06b6d4",
      glow: "rgba(6,182,212,0.55)",
    },
    neonDefault: {
      from: "#d4af37",
      to: "#f59e0b",
      glow: "rgba(212,175,55,0.55)",
    },
    reportsBorder: "rgba(96,165,250,0.45)",
    reportsBg:
      "linear-gradient(135deg,rgba(37,99,235,0.35),rgba(168,85,247,0.30))",
    reportsShadow:
      "0 0 12px rgba(59,130,246,0.35),0 0 22px rgba(168,85,247,0.18)",
    reportsShadowHover:
      "0 0 18px rgba(59,130,246,0.45),0 0 28px rgba(168,85,247,0.28)",
    reportsIcon: "#fbbf24",
    accordionBg:
      "linear-gradient(135deg,rgba(59,130,246,0.22),rgba(168,85,247,0.18))",
    accordionBgHover:
      "linear-gradient(135deg,rgba(59,130,246,0.32),rgba(168,85,247,0.26))",
    accordionShadow: "0 0 10px rgba(168,85,247,0.14)",
    accordionShadowOpen: "0 0 18px rgba(59,130,246,0.28)",
    accordionBodyBg: "rgba(0,0,0,0.22)",
    accordionIconColor: "#fbbf24",
    accordionLabelColor: "rgba(219,228,255,0.88)",
    accordionItemHoverBg:
      "linear-gradient(90deg,rgba(6,182,212,0.16),rgba(59,130,246,0.18),rgba(168,85,247,0.14))",
    accordionItemHoverShadow:
      "0 0 12px rgba(59,130,246,0.22),inset 0 0 12px rgba(6,182,212,0.10)",
    accordionItemHoverLabel: "#67e8f9",
    accordionItemHoverLabelShadow:
      "0 0 6px rgba(103,232,249,0.9),0 0 14px rgba(59,130,246,0.65)",
    accordionDotHover: "#60a5fa",
  },
  slateDark: {
    id: "slateDark",
    label: "Slate Dark",
    goldAccent: "#d4af37",
    iconColorActive: "#ffffff",
    cardBorderInactive: "#475569",
    cardHoverBorder: "rgba(56,189,248,0.30)",
    bgHover: "rgba(255,255,255,0.07)",
    bg: "linear-gradient(135deg,#0f172a 0%,#1e293b 55%,#334155 100%)",
    bgSolid: "#0f172a",
    shimmerBody: "linear-gradient(135deg,#0f172a 0%,#1e293b 55%,#334155 100%)",
    shimmerHighlight: "rgba(255,255,255,0.22)",
    bgCard: "rgba(255,255,255,0.05)",
    bgCardActive: "rgba(56,189,248,0.38)",
    bgActive: "rgba(56,189,248,0.18)",
    cardBorder: "rgba(255,255,255,0.14)",
    borderActive: "rgba(56,189,248,0.60)",
    cardIconBg: "rgba(255,255,255,0.09)",
    cardIconBgActive: "rgba(255,255,255,0.22)",
    headerBorder: "rgba(255,255,255,0.07)",
    dashboardBorder: "rgba(255,255,255,0.18)",
    accordionBorder: "rgba(255,255,255,0.18)",
    accordionBodyBorder: "rgba(255,255,255,0.13)",
    accordionBodyDivider: "rgba(255,255,255,0.07)",
    sectionBar: "#f472b6",
    sectionHeadingColor: "#f472b6",
    iconColor: "#fbbf24",
    text: "rgba(226,232,240,0.90)",
    textMuted: "rgba(226,232,240,0.55)",
    textActive: "#ffffff",
    dashboardText: "#f1f5f9",
    reportsText: "#ffffff",
    chevronColor: "rgba(255,255,255,0.80)",
    accent: "#38bdf8",
    accentBg: "rgba(56,189,248,0.16)",
    cardHoverBg: "rgba(56,189,248,0.09)",
    cardHoverShadow: "0 6px 18px rgba(56,189,248,0.18)",
    dashboardBg: "rgba(255,255,255,0.06)",
    reportDotInactive: "rgba(255,255,255,0.25)",
    activeIndicatorDot: "#ffffff",
    pickerBg: "rgba(255,255,255,0.06)",
    pickerBgHover: "rgba(255,255,255,0.11)",
    pickerDropdownBg: "rgba(15,23,42,0.97)",
    pickerItemSelectedBg: "rgba(255,255,255,0.10)",
    pickerItemHoverBg: "rgba(255,255,255,0.07)",
    pickerItemText: "rgba(255,255,255,0.72)",
    pickerItemBorder: "rgba(255,255,255,0.06)",
    scrollbarColor: "rgba(255,255,255,0.18)",
    tooltipBg: "rgba(15,23,42,0.97)",
    neonMasters: {
      from: "#0ea5e9",
      to: "#38bdf8",
      glow: "rgba(56,189,248,0.50)",
    },
    neonUtilities: {
      from: "#6366f1",
      to: "#818cf8",
      glow: "rgba(129,140,248,0.50)",
    },
    neonDefault: {
      from: "#38bdf8",
      to: "#7dd3fc",
      glow: "rgba(56,189,248,0.50)",
    },
    reportsBorder: "rgba(56,189,248,0.40)",
    reportsBg:
      "linear-gradient(135deg,rgba(14,165,233,0.30),rgba(99,102,241,0.25))",
    reportsShadow:
      "0 0 12px rgba(56,189,248,0.28),0 0 20px rgba(99,102,241,0.16)",
    reportsShadowHover:
      "0 0 18px rgba(56,189,248,0.42),0 0 28px rgba(99,102,241,0.26)",
    reportsIcon: "#fbbf24",
    accordionBg:
      "linear-gradient(135deg,rgba(14,165,233,0.20),rgba(99,102,241,0.16))",
    accordionBgHover:
      "linear-gradient(135deg,rgba(14,165,233,0.30),rgba(99,102,241,0.24))",
    accordionShadow: "0 0 10px rgba(99,102,241,0.14)",
    accordionShadowOpen: "0 0 18px rgba(56,189,248,0.28)",
    accordionBodyBg: "rgba(0,0,0,0.25)",
    accordionIconColor: "#fbbf24",
    accordionLabelColor: "rgba(226,232,240,0.90)",
    accordionItemHoverBg:
      "linear-gradient(90deg,rgba(56,189,248,0.14),rgba(99,102,241,0.16),rgba(14,165,233,0.12))",
    accordionItemHoverShadow:
      "0 0 10px rgba(56,189,248,0.18),inset 0 0 10px rgba(14,165,233,0.08)",
    accordionItemHoverLabel: "#7dd3fc",
    accordionItemHoverLabelShadow:
      "0 0 6px rgba(125,211,252,0.85),0 0 14px rgba(56,189,248,0.60)",
    accordionDotHover: "#38bdf8",
  },
  midnightRose: {
    id: "midnightRose",
    label: "Midnight Rose",
    goldAccent: "#d4af37",
    iconColorActive: "#ffffff",
    cardBorderInactive: "#6b3a4a",
    cardHoverBorder: "rgba(251,113,133,0.35)",
    bgHover: "rgba(255,255,255,0.07)",
    bg: "linear-gradient(160deg,#12080e 0%,#1c0f18 45%,#261525 100%)",
    bgSolid: "#12080e",
    shimmerBody: "linear-gradient(160deg,#12080e 0%,#1c0f18 45%,#261525 100%)",
    shimmerHighlight: "rgba(255,200,210,0.22)",
    bgCard: "rgba(255,255,255,0.055)",
    bgCardActive: "rgba(251,113,133,0.42)",
    bgActive: "rgba(251,113,133,0.20)",
    cardBorder: "rgba(255,255,255,0.13)",
    borderActive: "rgba(251,113,133,0.65)",
    cardIconBg: "rgba(255,255,255,0.09)",
    cardIconBgActive: "rgba(255,255,255,0.22)",
    headerBorder: "rgba(255,255,255,0.07)",
    dashboardBorder: "rgba(255,255,255,0.18)",
    accordionBorder: "rgba(255,255,255,0.18)",
    accordionBodyBorder: "rgba(255,255,255,0.13)",
    accordionBodyDivider: "rgba(255,255,255,0.07)",
    sectionBar: "#fb7185",
    sectionHeadingColor: "#fb7185",
    iconColor: "#fcd34d",
    text: "rgba(255,228,230,0.88)",
    textMuted: "rgba(255,228,230,0.52)",
    textActive: "#ffffff",
    dashboardText: "#fff1f2",
    reportsText: "#ffffff",
    chevronColor: "rgba(255,255,255,0.80)",
    accent: "#fb7185",
    accentBg: "rgba(251,113,133,0.18)",
    cardHoverBg: "rgba(251,113,133,0.09)",
    cardHoverShadow: "0 6px 18px rgba(251,113,133,0.20)",
    dashboardBg: "rgba(255,255,255,0.06)",
    reportDotInactive: "rgba(255,255,255,0.25)",
    activeIndicatorDot: "#ffffff",
    pickerBg: "rgba(255,255,255,0.06)",
    pickerBgHover: "rgba(255,255,255,0.11)",
    pickerDropdownBg: "rgba(18,8,14,0.97)",
    pickerItemSelectedBg: "rgba(255,255,255,0.10)",
    pickerItemHoverBg: "rgba(255,255,255,0.07)",
    pickerItemText: "rgba(255,255,255,0.72)",
    pickerItemBorder: "rgba(255,255,255,0.06)",
    scrollbarColor: "rgba(255,255,255,0.18)",
    tooltipBg: "rgba(18,8,14,0.97)",
    neonMasters: {
      from: "#be185d",
      to: "#fb7185",
      glow: "rgba(251,113,133,0.55)",
    },
    neonUtilities: {
      from: "#9d174d",
      to: "#f43f5e",
      glow: "rgba(244,63,94,0.50)",
    },
    neonDefault: {
      from: "#e11d48",
      to: "#fb7185",
      glow: "rgba(251,113,133,0.50)",
    },
    reportsBorder: "rgba(251,113,133,0.45)",
    reportsBg:
      "linear-gradient(135deg,rgba(190,24,93,0.35),rgba(244,63,94,0.28))",
    reportsShadow:
      "0 0 12px rgba(251,113,133,0.30),0 0 22px rgba(190,24,93,0.18)",
    reportsShadowHover:
      "0 0 18px rgba(251,113,133,0.48),0 0 28px rgba(190,24,93,0.28)",
    reportsIcon: "#fcd34d",
    accordionBg:
      "linear-gradient(135deg,rgba(190,24,93,0.22),rgba(244,63,94,0.16))",
    accordionBgHover:
      "linear-gradient(135deg,rgba(190,24,93,0.32),rgba(244,63,94,0.24))",
    accordionShadow: "0 0 10px rgba(244,63,94,0.14)",
    accordionShadowOpen: "0 0 18px rgba(251,113,133,0.30)",
    accordionBodyBg: "rgba(0,0,0,0.35)",
    accordionIconColor: "#fcd34d",
    accordionLabelColor: "rgba(255,228,230,0.88)",
    accordionItemHoverBg:
      "linear-gradient(90deg,rgba(251,113,133,0.16),rgba(244,63,94,0.18),rgba(190,24,93,0.13))",
    accordionItemHoverShadow:
      "0 0 12px rgba(251,113,133,0.22),inset 0 0 10px rgba(244,63,94,0.10)",
    accordionItemHoverLabel: "#fda4af",
    accordionItemHoverLabelShadow:
      "0 0 6px rgba(253,164,175,0.9),0 0 14px rgba(251,113,133,0.65)",
    accordionDotHover: "#fb7185",
  },
  warmGray: {
    id: "warmGray",
    label: "Warm Gray",
    goldAccent: "#d4af37",
    iconColorActive: "#000000",
    cardBorderInactive: "#94a3b8",
    cardHoverBorder: "rgba(15,118,110,0.35)",
    bgHover: "rgba(0,0,0,0.05)",
    bg: "linear-gradient(160deg,#f8f5f0 0%,#f1ece5 55%,#e8e0d5 100%)",
    bgSolid: "#f8f5f0",
    shimmerBody: "linear-gradient(160deg,#f8f5f0 0%,#f1ece5 55%,#e8e0d5 100%)",
    shimmerHighlight: "rgba(255,255,255,0.60)",
    bgCard: "rgba(15,118,110,0.12)",
    bgCardActive: "#ffffff",
    bgActive: "rgba(255,255,255,0.92)",
    cardBorder: "rgba(15,118,110,0.30)",
    borderActive: "#0f766e",
    cardIconBg: "rgba(15,118,110,0.18)",
    cardIconBgActive: "rgba(15,118,110,0.12)",
    headerBorder: "rgba(0,0,0,0.09)",
    dashboardBorder: "rgba(0,0,0,0.12)",
    accordionBorder: "rgba(0,0,0,0.10)",
    accordionBodyBorder: "rgba(0,0,0,0.08)",
    accordionBodyDivider: "rgba(0,0,0,0.06)",
    sectionBar: "#ea580c",
    sectionHeadingColor: "#ea580c",
    iconColor: "#0f766e",
    text: "#0f5b55",
    textMuted: "#78716c",
    textActive: "#000000",
    dashboardText: "#292524",
    reportsText: "#ffffff",
    chevronColor: "#292524",
    accent: "#0f766e",
    accentBg: "rgba(15,118,110,0.12)",
    cardHoverBg: "rgba(15,118,110,0.20)",
    cardHoverShadow: "0 6px 18px rgba(15,118,110,0.22)",
    dashboardBg: "rgba(15,118,110,0.10)",
    reportDotInactive: "rgba(0,0,0,0.20)",
    activeIndicatorDot: "#0f766e",
    pickerBg: "rgba(15,118,110,0.10)",
    pickerBgHover: "rgba(15,118,110,0.18)",
    pickerDropdownBg: "#faf9f7",
    pickerItemSelectedBg: "rgba(15,118,110,0.12)",
    pickerItemHoverBg: "rgba(0,0,0,0.04)",
    pickerItemText: "#374151",
    pickerItemBorder: "rgba(0,0,0,0.06)",
    scrollbarColor: "rgba(0,0,0,0.18)",
    tooltipBg: "rgba(41,37,36,0.95)",
    neonMasters: {
      from: "#0d9488",
      to: "#2dd4bf",
      glow: "rgba(15,118,110,0.35)",
    },
    neonUtilities: {
      from: "#ea580c",
      to: "#fb923c",
      glow: "rgba(234,88,12,0.35)",
    },
    neonDefault: {
      from: "#0f766e",
      to: "#14b8a6",
      glow: "rgba(15,118,110,0.35)",
    },
    reportsBorder: "rgba(15,118,110,0.35)",
    reportsBg:
      "linear-gradient(135deg,rgba(15,118,110,0.88),rgba(13,148,136,0.90))",
    reportsShadow: "0 4px 16px rgba(15,118,110,0.22)",
    reportsShadowHover: "0 6px 24px rgba(15,118,110,0.38)",
    reportsIcon: "#ffffff",
    accordionBg: "rgba(15,118,110,0.10)",
    accordionBgHover: "rgba(15,118,110,0.18)",
    accordionShadow: "0 1px 4px rgba(15,118,110,0.12)",
    accordionShadowOpen: "0 2px 10px rgba(15,118,110,0.22)",
    accordionBodyBg: "rgba(255,255,255,0.72)",
    accordionIconColor: "#0f766e",
    accordionLabelColor: "#0f5b55",
    accordionItemHoverBg: "rgba(255,255,255,0.75)",
    accordionItemHoverShadow: "none",
    accordionItemHoverLabel: "#292524",
    accordionItemHoverLabelShadow: "none",
    accordionDotHover: "#0f766e",
  },
};

export let C = THEMES.royalBlue;

export const acSx = {
  "& .MuiInputBase-root": {
    height: 32,
    fontSize: 12,
    padding: "0 6px !important",
    borderRadius: "8px",
    background: "rgba(255,255,255,0.14) !important",
    backdropFilter: "blur(8px)",
    color: "#fff",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255,255,255,0.28)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255,255,255,0.6)",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#fff" },
  "& .MuiInputBase-input": {
    padding: "0 !important",
    color: "#fff",
    fontSize: 12,
    "&::placeholder": { color: "#fff !important", opacity: 1 },
  },
  "& .MuiInputLabel-root": {
    fontSize: 11,
    color: "rgba(255,255,255,0.65)",
    top: "-3px",
  },
  "& .MuiInputLabel-shrink": { top: 0, color: "rgba(255,255,255,0.9)" },
  "& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.7)" },
  "& .MuiOutlinedInput-root.Mui-focused": {
    background: "transparent !important",
    backgroundColor: "transparent !important",
  },
};

export const hexToRgba = (hex, alpha) => {
  if (!hex) return `rgba(255, 255, 255, ${alpha})`;
  let h = hex.replace("#", "");
  if (h.length === 3)
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${isNaN(r) ? 255 : r}, ${isNaN(g) ? 255 : g}, ${isNaN(b) ? 255 : b}, ${alpha})`;
};

export const DASHBOARD_NAV_STYLE = `
  @keyframes homeBounce {
    0%, 100% { transform: translateY(0); }
    30% { transform: translateY(-3px); }
    50% { transform: translateY(0); }
    70% { transform: translateY(-1px); }
  }
  @keyframes arrowNudge {
    0%, 100% { transform: translateX(0); opacity: 1; }
    50% { transform: translateX(3px); opacity: 1; }
  }
  .dashboard-nav-icon {
    animation: homeBounce 1.6s ease-in-out infinite;
  }
  .dashboard-nav-arrow {
    animation: arrowNudge 1.2s ease-in-out infinite;
  }
  .dashboard-nav-btn:active {
    transform: scale(0.98);
  }
`;
